import React from 'react';

import { cn } from '../../../utils/cn.js';

export default function PortalHeading({ children, className, ...props }) {
  return (
    <h1
      {...props}
      className={cn(
        'font-lively text-[32px] font-bold leading-[38.4px] text-portal-text lg:text-[40px] lg:leading-[56px]',
        className,
      )}
    >
      {children}
    </h1>
  );
}
